import img1 from "./images/MohanAditya.png"
import img2 from "./images/Kshitij Sinha.jpeg"
import img3 from "./images/Mittapally.jpeg"
import img4 from "./images/IshitaAsthana.jpeg"
import img5 from "./images/Palak Chaudhry.jpeg"
import img6 from "./images/Vaishnavi_Tiwari.jpg"
import img7 from "./images/Umesh Karthik.jpeg"
import img8 from "./images/Vishant_Batta.jpg"
import img9 from "./images/Anmol_Agrawal.jpg"
import img10 from "./images/Anurag_Nidhi.jpg"
import img11 from "./images/Ankur_Shukla.jpg"
import img12 from "./images/YashasreeChandana.jpeg"
import img13 from "./images/Divyam.jpeg"

const details = [
  {
    name: "Sabbineni Mohan Aditya",
    src: img1,
    position: "Deputy Manager, Nayara Energy",
    content:
      "Since it's inception, I worked with many people in this chill CSI and with this CSI family, I learnt many things especially 'Think Outside of the box while you still can!' Just Rock On!"
  },
  {
    name: "Kshitij Sinha",
    src: img2,
    position: "Birkbeck, University of London",
    content:
      "I remember entering one of the pitching competitions of CSI with a super lane product, a device finder.CSI showed me the wonders of tech, innovation, economics, softwares and countless others, CSI family gives you a different kind of happiness, loved to be a part of it and can't wait for new Junta to experience!!"
  },
  {
    name: "Nivesh Mittapally",
    src: img3,
    position: "Software Engineer, BrowserStack",
    content:
      "CSI is a journey towards Innovation, which teaches many things in its way"
  },
  {
    name: "Ishitha Asthana",
    src: img4,
    position: "Software Engineer,Microsoft",
    content:
      "CSI is great place to bring your ideas to life, It gave me a family where I can discuss my thoughts and work together to create new things"
  },
  {
    name: "Palak Chaudhry",
    src: img5,
    position: "Senior Assosciate Data Scientist, Publicis Sapient",
    content:
      "CSI is a club I've seen grow in front of my own eyes! I owe it to CSI for my projects that helped me in getting Hands-On experience in the latest technology! The brainstorming sessions, workshops and chitchat with seniors were the best part. I couldn't have found a better bunch of friends who turned my family! The culture of CSI is something I really love. "
  },
  {
    name: "Vaishnavi Tiwari",
    src: img6,
    position: "Assosciate Product Manager, Swiggy",
    content:
      "CSI gave me the playground to experiment with all sorts of Ideas ranging from exciting projects to sci-fi movie nights!My Product Management journey also started with the projects that I was building here:)"
  },
  {
    name: "Umesh Karthik",
    src: img7,
    position: "Manager-CBG, Axis Bank",
    content: "Loved my time in the club:)"
  },
  {
    name: "Vishant Batta",
    src: img8,
    position: "Product Manager, Graphy",
    content:
      "Call it a clan, call it a family, call it a tribe, call it a club: the informality of CSI life is a blessed condition that means you will love and be loved for the rest of your life."
  },
  {
    name: "Anmol Agrawal",
    src: img9,
    position: "Product Manager,Joveo",
    content:
      "CSI has always been the fun place where we innovate the ways to chill out along with the social projects."
  },
  {
    name: "Anurag Nidhi",
    src: img10,
    position: "Development Architect, Standard Chartered Bank",
    content: "Sharing the bond of innovation and togetherness."
  },

  {
    name: "Ankur Shukla",
    src: img11,
    position: "Co-founder, Dhandolat",
    content:
      "The organization that build me to build an organization. If you want to do something out of the box just join CSI."
  },

  {
    name: "Yashasree Chandana",
    src: img12,
    position: "Data Analyst Intern, Perceptive Analytics",
    content:
      "CSI provided me an opportunity to dive deep in to my areas of interest to the fullest."
  },

  {
    name: "Divyam Gupta",
    src: img13,
    position: "Business Analyst Intern, OYO",
    content:
      "I joined CSI through the exciting 'Tech-Treasure Hunt' event and instantly CSI became mt go-to place. Innovation along with sustainability is the only way to Future.."
  }
]
export default details
